import type { SlideFields } from "@/types/Slide";

interface FreeformSlideThumbnailProps {
  slide: SlideFields;
}

export function FreeformSlideThumbnail({ slide }: FreeformSlideThumbnailProps) {
  if (slide?.imageId && slide?.imageUrl) {
    return (
      <img
        src={slide.imageUrl}
        alt={slide?.name ?? "Slide image"}
        className="rounded-t-lg w-full h-full object-cover"
      />
    );
  }

  return (
    <div className="text-gray-600 dark:text-gray-400 h-full flex items-center justify-center">
      <p>No content</p>
    </div>
  );
}
